import { FC, ReactNode } from "react";

type Props = {
  title?: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
};

const DefaultIcon = () => (
  <svg
    className="mx-auto h-12 w-12 text-[var(--evo-text-secondary)] opacity-60"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
    />
  </svg>
);

/** Shared empty table / list placeholder (Phase 5). */
export const EvoEmptyState: FC<Props> = ({
  title = "No data found",
  description,
  icon,
  className = "",
}) => (
  <div className={`py-10 text-center ${className}`}>
    {icon ?? <DefaultIcon />}
    <p className="mt-2 text-sm font-medium text-[var(--evo-text)]">{title}</p>
    {description ? (
      <p className="mt-1 text-sm text-[var(--evo-text-secondary)]">{description}</p>
    ) : null}
  </div>
);
